var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlipgoCollapseMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 28,
    viewBox: "0 0 14 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 98",
    d: "M14 28C12.1615 28 10.341 27.6379 8.64243 26.9343C6.94387 26.2307 5.40052 25.1995 4.1005 23.8995C2.80048 22.5995 1.76925 21.0561 1.06569 19.3576C0.362119 17.659 -6.92323e-07 15.8385 -6.11959e-07 14C-5.31596e-07 12.1615 0.362121 10.341 1.06569 8.64243C1.76925 6.94387 2.80049 5.40052 4.10051 4.1005C5.40053 2.80048 6.94387 1.76925 8.64243 1.06569C10.341 0.36212 12.1615 -8.5305e-07 14 -6.11959e-07L14 14L14 28Z",
    fill: "#3D3D3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlipgoCollapseMenu);
export default __webpack_public_path__ + "static/media/blipgoCollapseMenu.1a928044ad55a668cb468624c87aa5c8.svg";
export { ForwardRef as ReactComponent };